const sanityClient = require("@sanity/client")
const imageUrlBuilder = require("@sanity/image-url")

export const client = sanityClient({
  projectId: process.env.GATSBY_SANITY_PROJECT_ID,
  dataset: process.env.GATSBY_SANITY_DATASET,
  apiVersion: "2021-05-02",
  token: process.env.GATSBY_SANITY_TOKEN,
  useCdn: false, // `false` if you want to ensure fresh data
})

const builder = imageUrlBuilder(client)

export const urlFor = source => {
  return builder.image(source)
}
